export default __webpack_public_path__ + "static/bg5-h-159b99edc80f5a7abfd8fce14cbb7f77.jpg";